export default __webpack_public_path__ + "static/media/dropdown-arrow.bbd78e39.svg";